/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio, AiFillCloud, AiOutlineApi,AiOutlineCloudServer,AiOutlineGithub  } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper, } from "react-icons/fa";


export const servicesData = [
    // {
    //     id: 1,
    //     title: 'Marketing',
    //     icon: <BiShoppingBag/>
    // },
    // {
    //     id: 2,
    //     title: 'Content Writing',
    //     icon: <BiPencil /> 
    // },
    {
        id: 3,
        title: 'AI Model Training',
        icon: <AiFillCloud />
    },
    {
        id: 4,
        title: 'AI Research Engineer',
        icon: <BsClipboardData />
    },
    {
        id: 5,
        title: 'Software Development',
        icon: <BsCodeSlash />
    },
    {
        id: 6,
        title: 'Web Design',
        icon: <BiPencil /> 
    },
    {
        id: 7,
        title: 'Photography',
        icon: <FaCameraRetro />
    },
    {
        id: 7,
        title: 'Video Editing',
        icon: <FaVideo />
    },
    {
        id: 8,
        title: 'Ebook Writing',
        icon: <FaTabletAlt />
    },
    {
        id: 9,
        title: 'WordPress',
        icon: <AiOutlineCloudServer />
    },
    {
        id: 10,
        title: 'GitHub',
        icon: <AiOutlineGithub />
    },
    {
        id: 11,
        title: 'Postman',
        icon: <AiOutlineApi />
    },

    
    // {
    //     id: 13,
    //     title: 'Blog Posting',
    //     icon: <FaRegNewspaper />
    // },

]
